import { render, staticRenderFns } from "./BuilderColumn.vue?vue&type=template&id=da8452d0"
import script from "./BuilderColumn.vue?vue&type=script&lang=js"
export * from "./BuilderColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports